import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-2315a984")
const _hoisted_1 = { class: "flag" }
const _hoisted_2 = { class: "language-name" }
const _hoisted_3 = { class: "dropdown" }
const _hoisted_4 = { class: "dropdown-menu" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flag" }
const _hoisted_7 = { class: "language-name" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseImage = _resolveComponent("BaseImage")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["language-switch-dropdown", [
      _ctx.mode === 'mobile' ? 'slide-down' : 'hover-desktop',
      { 'is-open': _ctx.isOpen },
    ]]),
    ref: "dropdown"
  }, [
    _createElementVNode("button", {
      class: "current-language",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onTrigger && _ctx.onTrigger(...args)))
    }, [
      (_ctx.isLanguageLoaded)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("span", _hoisted_1, [
              (_ctx.currentLanguageIcon)
                ? (_openBlock(), _createBlock(_component_BaseImage, {
                    key: 0,
                    src: _ctx.currentLanguageIcon,
                    alt: _ctx.currentLanguageName,
                    global: ""
                  }, null, 8, ["src", "alt"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.currentLanguageName), 1),
            _createVNode(_component_SvgIcon, {
              class: "icon icon--small",
              src: `icons/arrow-down.svg`
            }, null, 8, ["src"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherLanguages, (lang) => {
          return (_openBlock(), _createElementBlock("li", {
            key: lang.code,
            onClick: ($event: any) => (_ctx.selectLanguage(lang.code)),
            class: "dropdown-option"
          }, [
            _createElementVNode("span", _hoisted_6, [
              (lang.src)
                ? (_openBlock(), _createBlock(_component_BaseImage, {
                    key: 0,
                    src: lang.src,
                    alt: lang.name,
                    global: ""
                  }, null, 8, ["src", "alt"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", _hoisted_7, _toDisplayString(lang.name), 1)
          ], 8, _hoisted_5))
        }), 128))
      ])
    ])
  ], 2))
}